import { useNavigate } from 'react-router-dom';

import Icon from 'components/icon/Icon';
import { cn, getTimeAgoLabel } from 'lib/utils';
import { useUpdateNotificationStatus } from 'services/notifications/hook';
import { NotificationData } from 'services/notifications/type';
import { captureUserActivity } from 'services/profile/api';
import { USER_ACTIVITY } from 'types';

export default function NotificationItem({ item }: { item: NotificationData }) {
  const navigate = useNavigate();

  const { mutate } = useUpdateNotificationStatus();

  const onView = () => {
    if (isUnread) {
      mutate({
        notification_id: [item.notification_id],
      });
      captureUserActivity(USER_ACTIVITY.APP_NOTIFICATIONS, item);
    }

    navigate(`/notifications/${item.category}`, {
      state: item,
    });
  };

  const isUnread = item?.status === 'unread';

  const iconName =
    item?.category.trim() === 'family_member'
      ? 'add_profile'
      : item.category.trim() === 'miscellaneous'
      ? 'misc'
      : item.category;

  return (
    <div
      className={cn(
        'bg-[#F3F4F6] rounded-xl p-4 pb-1 md:pb-4 cursor-pointer border border-[#F3F4F6] flex flex-col md:gap-4 md:flex-row md:items-center justify-between',
        isUnread && 'border border-primary bg-primary/5'
      )}
      onClick={onView}
    >
      <div className='flex items-center gap-3'>
        <div className='flex items-center justify-center bg-white rounded-md size-10 shrink-0'>
          <Icon icon={iconName} size={24} color='#4B5363' />
        </div>
        <div className=''>
          <h2 className='text-base font-semibold leading-tight lg:text-lg'>
            {item.header}
          </h2>
          <p className='text-sm leading-tight lg:text-base'>{item.body}</p>
        </div>
      </div>

      <div className='flex justify-end'>
        <p className='text-sm font-medium text-[#9CA3AF]'>
          {getTimeAgoLabel(item.created_at)}
        </p>
      </div>
    </div>
  );
}
